if (!customElements.get("cart-sample")) {

  class CartSample extends HTMLElement {
    constructor() {
      super();

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.checkMinPurchaseTimeoutID = -1;
      this.sampleGWP = this.querySelector('.cart-gwp');
      this.popup = this.querySelector('#cart-sample-popup');
      this.cartOverlayBG = this.popup.querySelector('.cart-overlay-bg');
      this.cartOverlay = this.popup.querySelector('.cart-overlay');
      this.addSampleButton = this.popup.querySelector('.cart-overlay__footer-btn');
      this.closePopupButton = this.popup.querySelector('.cart-overlay__close');
      this.sampleSelections = this.popup.querySelectorAll('.cart-overlay__product');
      this.addListeners();

      // Monitor ONLY the cart total attribute change in cart-samples element
      this.observer.observe(this.sampleGWP, { attributeFilter: ['data-cart-total'] });
    }

    disconnectedCallback() {
      this.removeListeners();
    }

    addListeners() {
      this.openSamplePopupEvent = theme.addDelegateEventListener(this, 'click', '.cart-gwp__placeholder', this.openSamplePopup.bind(this));
      this.closeSamplePopupEvent = theme.addDelegateEventListener(this, 'click', '.cart-overlay__close, .cart-overlay-bg', this.closeSamplePopup.bind(this));      
      this.selectSamplesEvent = theme.addDelegateEventListener(this, 'click', '.cart-overlay__product', this.selectSamples.bind(this));
      this.addSamplesEvent = theme.addDelegateEventListener(this, 'click', '.cart-overlay__footer-btn', this.addSamples.bind(this));
      this.removeSampleEvent = theme.addDelegateEventListener(this, 'click', '.cart-remove__link', this.removeSample.bind(this));
      this.checkMinPurchaseOnCheckoutEvent = theme.addDelegateEventListener(document, 'click', '#cartform [name="checkout"], .additional-checkout-buttons li, a[href*="/checkout"]', this.checkMinPurchaseOnCheckout.bind(this));
      this.observer = new MutationObserver(this.checkMinPurchaseOnCartChanged.bind(this));
    }

    removeListeners() {
      this.removeEventListener('click', this.openSamplePopupEvent);
      this.removeEventListener('click', this.closeSamplePopupEvent);
      this.removeEventListener('click', this.selectSamplesEvent);
      this.removeEventListener('click', this.addSamplesEvent);
      this.removeEventListener('click', this.removeSampleEvent);
      document.removeEventListener('click', this.checkMinPurchaseOnCheckoutEvent);
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    openSamplePopup(evt, delEl) {
      // Show warning message if total cart value is less than the minimum sample value requirements
      let cartValue = parseFloat(this.sampleGWP.dataset.cartTotal);
      let sampleMinValue = parseFloat(this.sampleGWP.dataset.sampleMin);
      if (cartValue < sampleMinValue) {
        theme.showQuickPopup(theme.strings.sampleMinPurchaseWarning.replace('[MIN_AMT]', theme.settings.sampleMinAmount), delEl);
        return false;
      }

      let sampleVariants = [...this.querySelectorAll('.cart-gwp__product:not([data-merge-cache=":"])')].map((el) => el.dataset.mergeCache.split(':')[0]);
      
      // select samples added into cart
      this.sampleSelections.forEach((el) => {
  
        // reset all is-active and is-disabled variants on the popup
        el.classList.remove('is-active', 'is-disabled'); 

        if (sampleVariants.includes(el.dataset.variant)) {
          el.dispatchEvent(new Event('click', { bubbles: true })); 
        }
      });

      // Show sample selection popup
      this.cartOverlayBG.classList.add('is-active');
      this.cartOverlay.classList.add('is-active');
    }

    closeSamplePopup(evt) {      
      evt.preventDefault();
      this.cartOverlayBG.classList.remove('is-active');
      this.cartOverlay.classList.remove('is-active');
    }

    selectSamples(evt, delEl) {
      delEl.classList.toggle('is-active');

      let notSelectedSamples = [...this.sampleSelections].filter((el) => !el.classList.contains('is-active'));
      let selectedSamplesCount = this.sampleSelections.length - notSelectedSamples.length;

      // Disable all other samples when 3 samples are selected
      notSelectedSamples.forEach((el) => {
        if (selectedSamplesCount == 3)
          el.classList.add('is-disabled');
        else
          el.classList.remove('is-disabled');
      });

      // Show the number of samples left
      let errorMsg = this.popup.querySelector('.cart_error');
      if (selectedSamplesCount == 3)
        errorMsg.innerHTML = theme.strings.sampleCount.noSamples;
      else if (selectedSamplesCount == 2)
        errorMsg.innerHTML = theme.strings.sampleCount.singleSample;
      else
        errorMsg.innerHTML = theme.strings.sampleCount.multipleSamples.replace('[COUNT]', 3 - selectedSamplesCount);

      // Toggle Add to Sample button
      if (selectedSamplesCount == 0)
        this.addSampleButton.classList.remove('is-active');
      else
        this.addSampleButton.classList.add('is-active');
    }

    addSamples(evt, delEl) {
      evt.preventDefault();

      clearTimeout(this.addSamplesTimeout);
        this.addSamplesTimeout = setTimeout(() => {
          delEl.classList.remove('is-active');
                
          let data = { updates: {} };

          this.sampleSelections.forEach((el) => {
            let key = el.dataset.variant;
            let qty = el.classList.contains('is-active') ? 1 : 0;
            data.updates[key] = qty;
          });
          
          fetch(theme.routes.cartUpdate, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/json"
            }
          }).
          then((response) => {
            if (!response.ok) {
              throw new Error("HTTP error! Status: ".concat(response.status));
            }
            document.dispatchEvent(
              new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
            );

            // Close popup
            this.closePopupButton.dispatchEvent(new Event('click', { bubbles: true }));
            
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error.message);
            this.dispatchEvent(new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: {
                error: error.message
              }
            }));
            // Uncertainty... Reload page.
            window.location.reload();
          });
      }, 700);
    }

    removeSample(evt, delEl) {
      evt.preventDefault();

      clearTimeout(this.removeSampleTimeout);
        this.removeSampleTimeout = setTimeout(() => {
          let data = { updates: {} };
          let key = delEl.closest('.cart-gwp__product').dataset.mergeCache;
          data.updates[key] = 0;

          delEl.closest('[data-merge-list-item]').classList.add('merge-item-refreshing');

          fetch(theme.routes.cartUpdate, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/json"
            }
          }).
          then((response) => {
            if (!response.ok) {
              throw new Error("HTTP error! Status: ".concat(response.status));
            }
            document.dispatchEvent(
              new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
            );

          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error.message);
            this.dispatchEvent(new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: {
                error: error.message
              }
            }));
            // Uncertainty... Reload page.
            window.location.reload();
          });
      }, 700);
    }

    checkMinPurchaseOnCheckout(evt, delEl) {
      // Show warning message if total cart value is less than the minimum sample value requirements
      let sampleCount = parseInt(this.dataset.sampleCount);
      let cartValue = parseFloat(this.sampleGWP.dataset.cartTotal);
      let cartMinValue = parseFloat(this.sampleGWP.dataset.sampleMin);

      if (sampleCount > 0 && cartValue < cartMinValue) {
        evt.preventDefault();
        evt.stopPropagation();
        theme.showQuickPopup(theme.strings.sampleMinPurchaseWarning.replace('[MIN_AMT]', theme.settings.sampleMinAmount), delEl);
        return false;
      }
    }

    checkMinPurchaseOnCartChanged(mutations) {
      clearTimeout(this.checkMinPurchaseTimeoutID);
      this.checkMinPurchaseTimeoutID = setTimeout(() => {
      
        mutations.forEach(function(mutation) {
          if (mutation.type === "attributes") {
      
            let cartValue = parseFloat(mutation.target.dataset.cartTotal);
            let cartMinValue = parseFloat(mutation.target.dataset.sampleMin);
            let samples = mutation.target.querySelectorAll('.cart-gwp__product:not([data-merge-cache=":"])');
      
            // Check old cart value with the new cart value - only run if different to avoid duplicate calls to the update cart
            if (samples.length > 0 && cartValue < cartMinValue) {
      
              let data = { updates: {} };
      
              for (let i = 0; i < samples.length; i++) {
                 data.updates[samples[i].dataset.mergeCache] = 0;
              }
      
              fetch(theme.routes.cartUpdate, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                  "Content-Type": "application/json"
                }
              })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("HTTP error! Status: ".concat(response.status));
                }
                document.dispatchEvent(
                new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
              });
            }
          }
        });
      }, 800); 
    }

  }
  
  customElements.define("cart-sample", CartSample);
}